var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagPl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17.4375,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17.4375,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(-0.08125) scale(0.00484375 0.00666667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 240,
    height: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAACWCAYAAADg+AXVAAAEWklEQVR4Ae3VwQnEMBQDUReRctJ/FenFaUKXgbew1/AZaaxz/RBAIEvgZC93OAIIXAIrAQJhAgQOh+d0BAisAwiECRA4HJ7TESCwDiAQJkDgcHhOR4DAOoBAmACBw+E5HQEC6wACYQIEDofndAQIrAMIhAkQOBye0xEgsA4gECZA4HB4TkeAwDqAQJgAgcPhOR0BAusAAmECBA6H53QECKwDCIQJEDgcntMRILAOIBAmQOBweE5HgMA6gECYAIHD4TkdAQLrAAJhAgQOh+d0BAisAwiECRA4HJ7TESCwDiAQJkDgcHhOR4DAOoBAmACBw+E5HQEC6wACYQIEDofndAQIrAMIhAkQOBye0xEgsA4gECZA4HB4TkeAwDqAQJgAgcPhOR0BAusAAmECBA6H53QECKwDCIQJEDgcntMRILAOIBAmQOBweE5HgMA6gECYAIHD4TkdAQLrAAJhAgQOh+d0BAisAwiECRA4HJ7TESCwDiAQJkDgcHhOR4DAOoBAmACBw+E5HQEC6wACYQIEDofndAQIrAMIhAkQOBye0xEgsA4gECZA4HB4TkeAwDqAQJgAgcPhOR0BAusAAmECBA6H53QECKwDCIQJEDgcntMRILAOIBAmQOBweE5HgMA6gECYAIHD4TkdAQLrAAJhAud73uuPgQ40O0BgD5gHPNwBAofDs5rN1VzmRmACW+BwBwgcDm/5kvtWc80JTGALHO4AgcPhWc3mai5zIzCBLXC4AwQOh7d8yX2rueYEJrAFDneAwOHwrGZzNZe5EZjAFjjcAQKHw1u+5L7VXHMCE9gChztA4HB4VrO5msvcCExgCxzuAIHD4S1fct9qrjmBCWyBwx0gcDg8q9lczWVuBCawBQ53gMDh8JYvuW8115zABLbA4Q4QOBye1Wyu5jI3AhPYAoc7QOBweMuX3Leaa05gAlvgcAcIHA7PajZXc5kbgQlsgcMdIHA4vOVL7lvNNScwgS1wuAMEDodnNZurucyNwAS2wOEOEDgc3vIl963mmhOYwBY43AECh8Ozms3VXOZGYAJb4HAHCBwOb/mS+1ZzzQlMYAsc7gCBw+FZzeZqLnMjMIEtcLgDBA6Ht3zJfau55gQmsAUOd4DA4fCsZnM1l7kRmMAWONwBAofDW77kvtVccwIT2AKHO0DgcHhWs7may9wITGALHO4AgcPhLV9y32quOYEJbIHDHSBwODyr2VzNZW4EJrAFDneAwOHwli+5bzXXnMAEtsDhDhA4HJ7VbK7mMjcCE9gChztA4HB4y5fct5prTmACW+BwBwgcDs9qNldzmRuBCWyBwx0gcDi85UvuW801JzCBLXC4AwQOh2c1m6u5zI3ABLbA4Q4QOBze8iX3reaaE5jAFjjcAQKHw7OazdVc5kZgAlvgcAcIHA5v+ZL7VnPNCUxgCxzuAIHD4VnN5moucyMwgS1wuAMEDoe3fMl9q7nmBCawBQ53gMDh8KxmczWXuf2+Va+BTWR5oQAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPl);
export default __webpack_public_path__ + "static/media/flag_pl.c6fa5d89250993be55317166da7f0cc5.svg";
export { ForwardRef as ReactComponent };